import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/ParcelPerform/parcelPerform.container"
    ).then((module) => ({
        default: module.ParcelPerform
    }))
);
